import { BllSubeler } from './../providers/bll/bll-subeler';
import { TopluFiyatDegistirPage } from './../pages/StokIslemleri/toplu-fiyat-degistir/toplu-fiyat-degistir';
import { MarkaeklemodalPage } from './../pages/Yonetim/MarkaIslemleri/markaeklemodal/markaeklemodal';
import { TeknikServisAnaSayfaPage } from './../pages/ServisKayit/teknik-servis-ana-sayfa/teknik-servis-ana-sayfa';
import { ServishareketdetayPage } from './../pages/ServisKayit/servishareketdetay/servishareketdetay';
import { YapilanIslerPage } from './../pages/Yonetim/yapilan-isler/yapilan-isler';
import { AksesuareklemodalPage } from './../pages/Yonetim/aksesuareklemodal/aksesuareklemodal';
import { TeslimEdilenListesiPage } from './../pages/ServisKayit/teslim-edilen-listesi/teslim-edilen-listesi';
import { ServisOdemeYapPage } from './../pages/ServisKayit/servis-odeme-yap/servis-odeme-yap';
import { ServisKayitArsivPage } from './../pages/ServisKayit/servis-kayit-arsiv/servis-kayit-arsiv';
import { ServishareketduzenlePage } from './../pages/ServisKayit/servishareketduzenle/servishareketduzenle';
import { ServisHareketPage } from './../pages/ServisKayit/servis-hareket/servis-hareket';
import { ServisDuzenlePage } from './../pages/ServisKayit/servis-duzenle/servis-duzenle';
import { ServisDetayPage } from './../pages/ServisKayit/servis-detay/servis-detay';
import { KayitFormPage } from './../pages/ServisKayit/kayit-form/kayit-form';
import { StokHareketleriPage } from './../pages/StokIslemleri/stok-hareketleri/stok-hareketleri';
import { PerakendeSatisFaturalariPage } from './../pages/faturaislemleri/perakende-satis-faturalari/perakende-satis-faturalari';
import { PerakendeFaturaDetayPage } from './../pages/faturaislemleri/perakende-fatura-detay/perakende-fatura-detay';
import { StokDegerRaporPage } from './../pages/Raporlars/stok-deger-rapor/stok-deger-rapor';
import { KasaVirmanislemiPage } from './../pages/Yonetim/KasaIslemleri/kasa-virmanislemi/kasa-virmanislemi';
import { Camera } from '@ionic-native/camera';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { HizliFiyatDegistirPage } from './../pages/PerakendeIslemleri/hizli-fiyat-degistir/hizli-fiyat-degistir';
import { UrunSatisRaporuPage } from './../pages/Raporlars/urun-satis-raporu/urun-satis-raporu';
import { KdvSatisRaporuPage } from './../pages/Raporlars/kdv-satis-raporu/kdv-satis-raporu';
import { KategoriBazliRaporPage } from './../pages/Raporlars/kategori-bazli-rapor/kategori-bazli-rapor';
import { MarkaBazliRaporPage } from './../pages/Raporlars/marka-bazli-rapor/marka-bazli-rapor';
import { KasaHareketleriRaporPage } from './../pages/Raporlars/kasa-hareketleri-rapor/kasa-hareketleri-rapor';
import { OdemeBeklenyenKrediKartlariPage } from './../pages/odeme-beklenyen-kredi-kartlari/odeme-beklenyen-kredi-kartlari';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { StokResimEkleGuncellePage } from './../pages/StokIslemleri/stok-resim-ekle-guncelle/stok-resim-ekle-guncelle';
import { BllKasalar } from './../providers/bll/bll-kasalar';
import { CekSenetDetayPage } from './../pages/CekSenetIslemleri/cek-senet-detay/cek-senet-detay';
import { BankaHavaleEftPage } from './../pages/BankaIslemleri/banka-havale-eft/banka-havale-eft';
import { BankaHareketPage } from './../pages/BankaIslemleri/banka-hareket/banka-hareket';
import { BankaEkleGuncellePage } from './../pages/BankaIslemleri/banka-ekle-guncelle/banka-ekle-guncelle';
import { BankListePage } from './../pages/BankaIslemleri/bank-liste/bank-liste';
import { KrediKartiHareketleriPage } from './../pages/BankaIslemleri/kredi-karti-hareketleri/kredi-karti-hareketleri';
import { KrediKartiOdemeIslemleriPage } from './../pages/BankaIslemleri/kredi-karti-odeme-islemleri/kredi-karti-odeme-islemleri';
import { KrediKartiIslemleriPage } from './../pages/BankaIslemleri/kredi-karti-islemleri/kredi-karti-islemleri';
import { CekSenetDurumDegistirPage } from './../pages/CekSenetIslemleri/cek-senet-durum-degistir/cek-senet-durum-degistir';
import { CekSenetListePage } from './../pages/CekSenetIslemleri/cek-senet-liste/cek-senet-liste';
import { CekSenetEkleGuncellePage } from './../pages/CekSenetIslemleri/cek-senet-ekle-guncelle/cek-senet-ekle-guncelle';
import { CekSenetAnaSayfaPage } from './../pages/CekSenetIslemleri/cek-senet-ana-sayfa/cek-senet-ana-sayfa';
import { BLLViewCariler } from './../providers/bll/bll-viewCariler';
import { BLLCariKartlar } from './../providers/bll/bll-carikart';
import { BllViewStoklar } from './../providers/bll/bll-ViewStoklar';
import { BllKdvGruplar } from './../providers/bll/bll-kdvgruplari';
import { BllKategoriler } from './../providers/bll/bll-kategoriler';
import { BllMarkalar } from './../providers/bll/bll-markalar';
import { BllBirimler } from './../providers/bll/bll-birimler';
import { BllBarcode } from './../providers/bll-nlbarcode';
import { BllStoklar } from './../providers/bll/bll-stoklar';
import { SyncProvider } from './../providers/syncProvider';
import { DataSyncPage } from './../pages/Yonetim/data-sync/data-sync';
import { ParametreAyarlariPage } from './../pages/Yonetim/parametre-ayarlari/parametre-ayarlari';
import { ParaUstuModalPage } from './../pages/PerakendeIslemleri/para-ustu-modal/para-ustu-modal';
import { KalemOnaylaPage } from './../pages/faturaislemleri/kalem-onayla/kalem-onayla';
import { FaturaonaylaPage } from './../pages/faturaislemleri/faturaonayla/faturaonayla';
import { PerakendeSatisPage } from './../pages/PerakendeIslemleri/perakende-satis/perakende-satis';
import { BorcluHesaplarReportPage } from './../pages/Raporlars/borclu-hesaplar-report/borclu-hesaplar-report';
import { AlacakliHesaplarReportPage } from './../pages/Raporlars/alacakli-hesaplar-report/alacakli-hesaplar-report';
import { ProgramAyarlariPage } from './../pages/Yonetim/program-ayarlari/program-ayarlari';
import { PagesProvider } from './../providers/pages-provider';
import { FaturaDetayGosterPage } from './../pages/faturaislemleri/fatura-detay-goster/fatura-detay-goster';
import { SatisFaturaListesiPage } from './../pages/faturaislemleri/satis-fatura-listesi/satis-fatura-listesi';
import { AlisFaturaListesiPage } from './../pages/faturaislemleri/alis-fatura-listesi/alis-fatura-listesi';
import { SatisfaturasiolusturPage } from './../pages/faturaislemleri/satisfaturasiolustur/satisfaturasiolustur';
import { FaturaAnaSayfaPage } from './../pages/faturaislemleri/fatura-ana-sayfa/fatura-ana-sayfa';
import { ServerConfigPage } from './../pages/Yonetim/server-config/server-config';
import { KasiyerBazliRaporPage } from './../pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor';
import { GrupEkleGuncellePage } from './../pages/Yonetim/CariGrupIslemleri/grup-ekle-guncelle/grup-ekle-guncelle';
import { GrupListesiPage } from './../pages/Yonetim/CariGrupIslemleri/grup-listesi/grup-listesi';
import { AlisFaturalariPage } from './../pages/faturaislemleri/alis-faturalari/alis-faturalari';
import { BllRememberAcc } from './../providers/bll/bll-remember-acc';
import { RaporAnaSayfaPage } from './../pages/Raporlars/rapor-ana-sayfa/rapor-ana-sayfa';
import { MarkaListesiPage } from './../pages/Yonetim/MarkaIslemleri/marka-listesi/marka-listesi';
import { MarkaEklePage } from './../pages/Yonetim/MarkaIslemleri/marka-ekle/marka-ekle';
import { BirimListePage } from './../pages/Yonetim/BirimIslemleri/birim-liste/birim-liste';
import { BirimeklePage } from './../pages/Yonetim/BirimIslemleri/birimekle/birimekle';
import { AciklamaListePage } from './../pages/Yonetim/aciklama-liste/aciklama-liste';
import { AciklamaeklePage } from './../pages/Yonetim/aciklamaekle/aciklamaekle';
import { GelirgidereklePage } from './../pages/Yonetim/gelirgider/gelirgiderekle/gelirgiderekle';
import { HareketdetayPage } from './../pages/CariIslemleri/hareketdetay/hareketdetay';
import { CariHareketleriPage } from './../pages/CariIslemleri/cari-hareketleri/cari-hareketleri';
import { CarialacakdekontPage } from './../pages/CariIslemleri/carialacakdekont/carialacakdekont';
import { KasaeklePage } from './../pages/Yonetim/KasaIslemleri/kasaekle/kasaekle';
import { KasalistePage } from './../pages/Yonetim/KasaIslemleri/kasaliste/kasaliste';
import { KullaniciListePage } from './../pages/Yonetim/kullanici-liste/kullanici-liste';
import { KullanicieklePage } from './../pages/Yonetim/kullaniciekle/kullaniciekle';
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { EtiketlistesiPage } from './../pages/StokIslemleri/etiketlistesi/etiketlistesi';
import { EtiketbasPage } from './../pages/StokIslemleri/etiketbas/etiketbas';
import { ReportsPage } from './../pages/Raporlars/reports/reports';
import { DalProvider } from './../providers/dal/dal';
import { BarcodeScannerProvider } from './../providers/barcode-scanner-provider';
import { OzetPage } from './../pages/faturaislemleri/ozet/ozet';
import { CarisecPage } from './../pages/faturaislemleri/carisec/carisec';
import { CariIslemPage } from './../pages/CariIslemleri/cari-islem/cari-islem';
import { GirisPage } from './../pages/giris/giris';
import { SayimGirisiPage } from './../pages/StokIslemleri/sayim-girisi/sayim-girisi';
import { CariOdemePage } from './../pages/cari-odeme/cari-odeme';
import { StokeklePage } from './../pages/StokIslemleri/stokekle/stokekle';
import { HttpModule } from '@angular/http';
import { Ortak } from './../providers/ortak';
import { Servis } from './../providers/servis';
import { BllOrtak } from './../providers/bll/bll-ortak';
import { CarilerPage } from './../pages/CariIslemleri/cariler/cariler';
import { CarieklePage } from './../pages/CariIslemleri/cariekle/cariekle';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { CariTahsilatPage } from '../pages/CariIslemleri/cari-tahsilat/cari-tahsilat';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { CalendarModule } from "ion2-calendar";
import { Flashlight } from '@ionic-native/flashlight';
import { PersonelPage } from '../pages/Yonetim/personel/personel';
import { CariborcdekontPage } from '../pages/CariIslemleri/cariborcdekont/cariborcdekont';
import { GelirgiderPage } from '../pages/Yonetim/gelirgider/gelirgider';
import { KategoriEklePage } from '../pages/Yonetim/KategoriIslemleri/kategori-ekle/kategori-ekle';
import { KategoriListePage } from '../pages/Yonetim/KategoriIslemleri/kategori-liste/kategori-liste';
import { TanımAnaPage } from '../pages/Tanımlamalar/tanım-ana/tanım-ana';
import { DashAnaSayfaPage } from '../pages/dash-ana-sayfa/dash-ana-sayfa';
import { SelectSearchableModule } from 'ionic-select-searchable';
import { BllResimler } from '../providers/bll/bll-resimler';
import { StokDetayPage } from '../pages/StokIslemleri/stok-detay/stok-detay';
import { File } from '@ionic-native/file';
import { BekleyenListesiPage } from '../pages/ServisKayit/bekleyen-listesi/bekleyen-listesi';
import { IsListesiPage } from '../pages/ServisKayit/is-listesi/is-listesi';
import { IsdurumPage } from '../pages/Yonetim/isdurum/isdurum';
import { IsdurumkayitPage } from '../pages/Yonetim/isdurumkayit/isdurumkayit';
 
import { SubelerPage } from '../pages/Yonetim/subeler/subeler';
// import { NativeAudio } from '@ionic-native/native-audio';
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    CarieklePage,
    CarilerPage,
    StoklarPage,
    StokeklePage,
    CariTahsilatPage,
    CariOdemePage,
    SayimGirisiPage,
    GirisPage,
    GelirgiderPage,
    CariIslemPage,
    CarisecPage,
    OzetPage,
    ReportsPage,
    EtiketbasPage,
    EtiketlistesiPage,
    YonetimAnaSayfaPage,
    PersonelPage,
    KullanicieklePage,
    KullaniciListePage,
    KasalistePage,
    KasaeklePage,
    CariborcdekontPage,
    CarialacakdekontPage,
    CariHareketleriPage,
    HareketdetayPage,
    GelirgidereklePage,
    AciklamaeklePage,
    AciklamaListePage,
    BirimeklePage,
    BirimListePage,
    KategoriEklePage,
    KategoriListePage,
    MarkaEklePage,
    MarkaListesiPage,
    RaporAnaSayfaPage,
    AlisFaturalariPage,
    TanımAnaPage,
    GrupListesiPage,
    GrupEkleGuncellePage,
    AlisFaturalariPage,
    DashAnaSayfaPage,
    KasiyerBazliRaporPage,
    ServerConfigPage,
    FaturaAnaSayfaPage,
    SatisfaturasiolusturPage,
    AlisFaturaListesiPage,
    SatisFaturaListesiPage,
    FaturaDetayGosterPage,
    ProgramAyarlariPage,
    AlacakliHesaplarReportPage,
    BorcluHesaplarReportPage,
    PerakendeSatisPage,
    FaturaonaylaPage,
    KalemOnaylaPage,
    ParaUstuModalPage,
    ParametreAyarlariPage,
    DataSyncPage,
    CekSenetAnaSayfaPage,
    CekSenetEkleGuncellePage,
    CekSenetListePage,
    CekSenetDurumDegistirPage,
    KrediKartiIslemleriPage,
    CekSenetDetayPage,
    StokResimEkleGuncellePage,
    StokDetayPage,
    KrediKartiIslemleriPage,
    KrediKartiOdemeIslemleriPage,
    KrediKartiHareketleriPage,
    BankListePage,
    BankaEkleGuncellePage,
    BankaHareketPage,
    BankaHavaleEftPage,
    OdemeBeklenyenKrediKartlariPage,
    KasaHareketleriRaporPage,
    MarkaBazliRaporPage,
    KategoriBazliRaporPage,
    KdvSatisRaporuPage,
    UrunSatisRaporuPage,
    HizliFiyatDegistirPage,
    KasaVirmanislemiPage,
    StokDegerRaporPage,
    PerakendeFaturaDetayPage,
    PerakendeSatisFaturalariPage,
    StokHareketleriPage,
    BekleyenListesiPage,
    HareketdetayPage,
    IsListesiPage,
    KayitFormPage,
    ServisDetayPage,
    ServisDuzenlePage,
    ServisHareketPage,
    ServishareketduzenlePage,
    ServisKayitArsivPage,
    ServisOdemeYapPage,
    TeslimEdilenListesiPage,
    AksesuareklemodalPage,
    IsdurumPage,
    IsdurumkayitPage,
    YapilanIslerPage,
    ServishareketdetayPage,
    TeknikServisAnaSayfaPage,
    MarkaeklemodalPage,
    TopluFiyatDegistirPage,
    SubelerPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    SelectSearchableModule,
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          backButtonText: 'Geri'
        }
      }
    }),

    CalendarModule,

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CarieklePage,
    CarilerPage,
    StoklarPage,
    StokeklePage,
    CariTahsilatPage,
    CariOdemePage,
    SayimGirisiPage,
    GirisPage,
    GelirgiderPage,
    CariIslemPage,
    CarisecPage,
    OzetPage,
    ReportsPage,
    EtiketbasPage,
    EtiketlistesiPage,
    YonetimAnaSayfaPage,
    PersonelPage,
    KullanicieklePage,
    KullaniciListePage,
    KasalistePage,
    KasaeklePage,
    CariborcdekontPage,
    CarialacakdekontPage,
    CariHareketleriPage,
    HareketdetayPage,
    GelirgidereklePage,
    AciklamaeklePage,
    AciklamaListePage,
    BirimeklePage,
    BirimListePage,
    KategoriEklePage,
    KategoriListePage,
    MarkaEklePage,
    MarkaListesiPage,
    RaporAnaSayfaPage,
    GrupListesiPage,
    GrupEkleGuncellePage,
    AlisFaturalariPage,
    DashAnaSayfaPage,
    KasiyerBazliRaporPage,
    ServerConfigPage,
    FaturaAnaSayfaPage,
    SatisfaturasiolusturPage,
    AlisFaturaListesiPage,
    SatisFaturaListesiPage,
    FaturaDetayGosterPage,
    ProgramAyarlariPage,
    AlacakliHesaplarReportPage,
    BorcluHesaplarReportPage,
    PerakendeSatisPage,
    FaturaonaylaPage,
    KalemOnaylaPage,
    ParaUstuModalPage,
    ParametreAyarlariPage,
    DataSyncPage,
    CekSenetAnaSayfaPage,
    CekSenetEkleGuncellePage,
    CekSenetListePage,
    CekSenetDurumDegistirPage,
    KrediKartiIslemleriPage,
    CekSenetDetayPage,
    StokResimEkleGuncellePage,
    StokDetayPage,
    KrediKartiOdemeIslemleriPage,
    KrediKartiHareketleriPage,
    BankListePage,
    BankaEkleGuncellePage,
    BankaHareketPage,
    BankaHavaleEftPage,
    OdemeBeklenyenKrediKartlariPage,
    KasaHareketleriRaporPage,
    MarkaBazliRaporPage,
    KategoriBazliRaporPage,
    KdvSatisRaporuPage,
    UrunSatisRaporuPage,
    HizliFiyatDegistirPage,
    KasaVirmanislemiPage,
    StokDegerRaporPage,
    PerakendeFaturaDetayPage,
    PerakendeSatisFaturalariPage,
    StokHareketleriPage,
    BekleyenListesiPage,
    HareketdetayPage,
    IsListesiPage,
    KayitFormPage,
    ServisDetayPage,
    ServisDuzenlePage,
    ServisHareketPage,
    ServishareketduzenlePage,
    ServisKayitArsivPage,
    ServisOdemeYapPage,
    TeslimEdilenListesiPage,
    AksesuareklemodalPage,
    IsdurumPage,
    IsdurumkayitPage,
    YapilanIslerPage,
    ServishareketdetayPage,
    TeknikServisAnaSayfaPage,
    MarkaeklemodalPage,
    TopluFiyatDegistirPage,
    SubelerPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    BllOrtak,
    Servis,
    Ortak,
    BarcodeScanner,
    FileTransfer,
    File,
    FileTransferObject,
    BllRememberAcc,
    Flashlight,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    BllBirimler,
    BllBarcode,
    SyncProvider,
    BllStoklar,
    Ortak,
    Servis,
    AndroidFullScreen,
    BllOrtak,
    PagesProvider,
    Camera,
    BarcodeScannerProvider,
    DalProvider,
    BllMarkalar,
    BllKategoriler,
    BllKdvGruplar,
    BllViewStoklar,
    BLLCariKartlar,
    BLLViewCariler,
    BllKasalar,
    BllResimler,
    // NativeAudio,
    BllSubeler,



  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts